import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import CustomRoutes from './routes/CustomRoutes';
import '../src/styles.css';
import { Layout, Spin, ConfigProvider } from 'antd';
import { PRIMARY_COLOR, WHITE_COLOR_BG, SUCCESS_COLOR } from './constants/color';
import WindowDimensionProvider from './hooks/WindowDimensionProvider';
import UserSettingProvider from './hooks/UserSettingProvider';
import MenuNotificationProvider from './hooks/MenuNotificationProvider';


const { Content } = Layout;

function App() {
  return (
    <UserSettingProvider>
    <ConfigProvider
      theme={{
        token: {
          colorSuccess: SUCCESS_COLOR,
          colorPrimary: PRIMARY_COLOR,
          colorBgLayout: WHITE_COLOR_BG,
          fontSize: 16,
        },
        components: {
          Modal: {
            wireframe: true,
            padding: 12,
            bodyStyle: { padding: 12 }
          },
          Tooltip: {
            trigger: ["hover"],
          },
          Table: {
            fontSize: 14,
          },
        },
      }}>
     <WindowDimensionProvider>
      <MenuNotificationProvider>
        <React.Suspense fallback={
          <Layout>
            <Content>
              <Spin  size="large" tip="Loading..."/>
            </Content>
          </Layout>
        }>
          <Router>
            <div className="App">
              <CustomRoutes />
            </div>
          </Router>
        </React.Suspense>
      </MenuNotificationProvider>
      </WindowDimensionProvider>
    </ConfigProvider>
    </UserSettingProvider>
  );
}

export default App;
